<div class="picklist-kits overflow-auto">
  <div
    class="overlay"
    lumAppLoader
    [loading]="loading"
    [classes]="'loading blur'"
  ></div>
  <table
    *ngIf="sortedOrderItems.length; else empty"
    class="lum-table lum-table--classic"
  >
    <thead>
      <tr>
        <th></th>
        <th>Kit SKU</th>
        <th>Kit Product Name</th>
        <th>SKU</th>
        <th>Product Name</th>
        <th>Description</th>
        <th>Warehouse</th>
        <th>Location</th>
        <th>Ord. Units</th>
        <th>UOM</th>
      </tr>
    </thead>
    <tbody>
      <ng-container
        *ngFor="let item of sortedOrderItems; let i = index; trackBy: trackById"
      >
        <tr>
          <th>
            <button
              *ngIf="item?.rfq?.kit_items?.length"
              (click)="toggleKitItems(i)"
              mat-icon-button
            >
              <mat-icon>{{
                !showKitItems[i] ? 'expand_more' : 'expand_less'
              }}</mat-icon>
            </button>
          </th>
          <td>
            {{
              item?.rfq?.type === eItemType.KIT ? item?.rfq?.internal_sku : 'N/A'
            }}
          </td>
          <td>
            {{
              item?.rfq?.type === eItemType.KIT ? item?.rfq?.product_name : 'N/A'
            }}
          </td>
          <td>
            {{
              item?.rfq?.type !== eItemType.KIT ? item?.rfq?.internal_sku : 'N/A'
            }}
          </td>
          <td>
            {{
              item?.rfq?.type !== eItemType.KIT ? item?.rfq?.product_name : 'N/A'
            }}
          </td>
          <td>
            {{ item?.rfq?.product_description | removeHtml }}
          </td>
          <td>{{ item?.pickingWarehouse }}</td>
          <td>{{ item?.pickingLocation }}</td>
          <td>{{ item?.ordered_qty | decimalPlaces }}</td>
          <td>
            {{
              item?.rfq?.type !== eItemType.KIT ? item?.ordered_uom?.name : 'N/A'
            }}
          </td>
        </tr>

        <ng-container *ngIf="item?.rfq?.kit_items?.length">
          <ng-container *ngIf="showKitItems[i]">
            <tr
              *ngFor="let kit of item?.rfq?.kit_items; trackBy: trackById"
              class="kit-list-item__row"
            >
              <td></td>
              <td></td>
              <td></td>

              <td>{{ kit?.product?.internal_sku }}</td>
              <td>{{ kit?.product?.product_name }}</td>
              <td>
                {{ kit?.product?.product_description | removeHtml }}
              </td>
              <td>
                {{ kit?.pickingWarehouse }}
              </td>
              <td>
                {{ kit?.pickingLocation }}
              </td>
              <td>{{ kit?.base_uom_quantity | decimalPlaces }}</td>
              <td>{{ kit?.unit_of_measure?.name || 'N/A' }}</td>
            </tr>
          </ng-container>
        </ng-container>
      </ng-container>
    </tbody>
  </table>

  <ng-template #empty>
    <lum-ui-empty-page title="No records available."></lum-ui-empty-page>
  </ng-template>
</div>
